import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BaseModule } from "./base/base.module";
import { CallCenterModule } from "./call-center/call-center.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxsModule } from "@ngxs/store";
import { RoleBasedService } from "./services/role-based.service";
import { RoleState } from "./state/roleManagement.state";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { InterceptorService } from "./services/interceptor.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TableModule } from "primeng/table";
import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { TokenInterceptorService } from "./services/token-interceptor.service";
import { ContactsService } from "./services/contacts.service";
import { CommonService } from "./services/common.service";
import { environment } from "../environments/environment";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { SetTargetsModule } from "./set-targets/set-targets.module";
import { PopoverModule } from "ngx-bootstrap/popover";
import { ManagePackageLeadsModule } from "./centre-manager/manage-package-leads/manage-package-leads.module";
import { TooltipModule } from "primeng/tooltip";
import { ChartModule } from "primeng/chart";
import { RadioButtonModule } from "primeng/radiobutton";
import { TaskSchedulerListComponent } from "./task-scheduler-list/task-scheduler-list.component";
import { IntegrationInterceptor } from "./services/integration.interceptor";
@NgModule({
  declarations: [
    AppComponent,
    TaskSchedulerListComponent,
  ],
  imports: [
    BrowserModule,
    ChartModule,
    RadioButtonModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    TooltipModule,
    ReactiveFormsModule,
    TableModule,
    NgxsModule.forRoot([RoleState]),
    BaseModule,
    CallCenterModule,
    ManagePackageLeadsModule,
    ToastModule,
    BrowserAnimationsModule,
    AccordionModule.forRoot(),
    SetTargetsModule,
    PopoverModule.forRoot(),
  ],
  providers: [
    RoleBasedService,
    ContactsService,
    CommonService,

    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IntegrationInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
